module.exports = __webpack_public_path__ + "static/media/profile1.85326344.png";